/*
 * @Author: your name
 * @Date: 2021-07-08 10:34:51
 * @LastEditTime: 2021-08-06 09:23:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\settlement.js
 */
export default [
    {
        path: '/settlements',
        component: resolve => require(['../../views/settlement/settlement.vue'], resolve),
        meta: { title: '待结算列表' }
    },
    {
        path: '/reconciliations',
        component: resolve => require(['../../views/settlement/reconciliations.vue'], resolve),
        meta: { title: '待对账结算' }
    },
    {
        path: '/settlementRecordss',
        component: resolve => require(['../../views/settlement/settlementRecords.vue'], resolve),
        meta: { title: '结算列表' }
    },
    {
        path: '/chooseOrder',
        component: resolve => require(['../../views/settlement/chooseOrder.vue'], resolve),
        meta: { title: '选择订单' }
    },
    {
        path: '/settlements/finalHistoryList',
        component: resolve => require(['../../views/settlement/finalHistoryList.vue'], resolve),
        meta: { title: '决算记录列表' }
    },
    {
        path: '/settlements/cashSettlementManagement',
        component: resolve => require(['../../views/settlement/cashSettlementManagement.vue'], resolve),
        meta: { title: '个人现结结算管理' }
    },    
    {
        path: '/preview',
        component: resolve => require(['../../views/settlement/preview.vue'], resolve),
        meta: { title: '预览结算单' }
    },
    {
        path: '/previews',
        component: resolve => require(['../../views/settlement/previews.vue'], resolve),
        meta: { title: '预览结算单' }
    },
    {
        path: '/homePage',
        component: resolve => require(['../../views/homePage/homePage.vue'], resolve),
        meta: { title: '首页待办' }
    },
    {
        path: '/alarm',
        component: resolve => require(['../../views/alarm/alarm.vue'], resolve),
        meta: { title: '业务告警' }
    },
    {
        path: '/details',
        component: resolve => require(['../../views/alarm/details.vue'], resolve),
        meta: { title: '系统消息' }
    },
    {
        path: '/moneyMonitor',
        component: resolve => require(['../../views/moneyMonitor/moneyMonitor.vue'], resolve),
        meta: { title: '资金监控' }
    }
]



// WEBPACK FOOTER //
// ./src/SRM/router/modules/settlement.js